module.exports = __webpack_public_path__ + "img/visitorsPage_bg.cc7bdb6d.png";